import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { CacheInterceptor } from './interceptors/cache.interceptor';
import { AuthService } from './shared/services/ecommerce/authService.service';
import { AuthInterceptor } from './interceptors/auth-ecommerce.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideClientHydration(withEventReplay()),
		provideAnimationsAsync(),
		provideAnimations(),
		provideHttpClient(withFetch(), withInterceptors([CacheInterceptor, AuthInterceptor])),
		providePrimeNG({
			translation: {
				firstDayOfWeek: 1,
				dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
				dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
				dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
				monthNames: [
					'Enero',
					'Febrero',
					'Marzo',
					'Abril',
					'Mayo',
					'Junio',
					'Julio',
					'Agosto',
					'Septiembre',
					'Octubre',
					'Noviembre',
					'Diciembre'
				],
				monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
				today: 'Hoy',
				clear: 'Limpiar',
				dateFormat: 'dd/mm/yy',
				weekHeader: 'Sm'
				//translations
			},
			theme: {
				preset: Aura
			}
		})
	]
};
